import api from '@/lib/api';

export type Platform = 'ANDROID' | 'IOS';

export interface AppVersionAdmin {
  platform: Platform;
  latestVersion: string;
  minimumVersion: string;
  updateMessage: string | null;
  storeUrl: string | null;
}

export const adminAppVersionsApi = {
  list: async (): Promise<AppVersionAdmin[]> => {
    const response = await api.get('/app/versions');
    return response.data;
  },

  update: async (payload: AppVersionAdmin): Promise<void> => {
    await api.post('/app/update-version', {
      platform: payload.platform,
      latestVersion: payload.latestVersion,
      minimumVersion: payload.minimumVersion,
      updateMessage: payload.updateMessage,
      // AppVersionUpdateRequestDTO.storeUrl is non-nullable on the backend.
      storeUrl: payload.storeUrl ?? '',
    });
  },
};
